var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCashIcon = function SvgCashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M22 36.783V43M12.327 35.219c-.203 2.587-.4 3.986-1.706 5.85M31.593 35.219c.204 2.587.401 3.986 1.707 5.85M2.565 24.652c.375 1.69 1.836 2.978 3.567 2.978h31.736c1.731 0 3.19-1.289 3.58-2.976.492-2.131 1.006-4.097 1.006-10.339 0-6.241-.514-8.207-1.006-10.34C41.058 2.29 39.599 1 37.868 1H6.132C4.4 1 2.94 2.288 2.565 3.978c-.496 2.234-1.02 4.285-1.02 10.337s.524 8.104 1.02 10.337M33.38 14.341l2.095-.026M8.526 14.341l2.095-.026"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M25.838 10.12s-1.443-1.608-3.783-1.407c-2.34.2-3.467 1.638-3.467 3.08 0 4.204 7.25 1.29 7.25 5.602 0 2.222-4.81 3.791-7.675 1.176"
  })));
};
export default SvgCashIcon;